import React from 'react';
import Intent from '../../types/BotBuilder/Intent';
import Slot from '../../types/BotBuilder/Slot';
import BotResponseTreeNode from '../../types/BotBuilder/BotResponseTreeNode';
import { SystemVariableDto } from '../../services/SystemVariableService/SystemVariableService';

export interface BotBuilderContextProps {
  intent: Intent | null;
  setIntent: React.Dispatch<React.SetStateAction<Intent | null>>;
  intentHasChanged: boolean;
  setIntentHasChanged: React.Dispatch<React.SetStateAction<boolean>>;
  slots: Slot[];
  setSlots: React.Dispatch<React.SetStateAction<Slot[]>>;
  refreshSlots: () => Promise<void>;
  updateSlot: (slot: Slot, intentId: number) => Promise<Slot | void>;
  deleteSlot: (
    slotId: number,
    index: number,
    intentId: number
  ) => Promise<void>;
  createSlot: (newSlot: Slot) => Promise<Slot | void>;
  onNodeUpdate: (node: BotResponseTreeNode) => void;
  onNodeDelete: (node: BotResponseTreeNode) => void;
  addNode: (node: BotResponseTreeNode) => void;
  unconnectedNodes: BotResponseTreeNode[];
  setUnconnectedNodes: React.Dispatch<
    React.SetStateAction<BotResponseTreeNode[]>
  >;
  removeNode: (node: BotResponseTreeNode) => void;
  intentSlotMap: Record<string, any>;
  systemVariables: SystemVariableDto[];
  setSystemVariables: React.Dispatch<React.SetStateAction<SystemVariableDto[]>>;
  startInitializing: (intentId: number) => void;
  finishInitializing: () => void;
}

const BotBuilderContext = React.createContext<BotBuilderContextProps>({
  intent: null,
  setIntent: () => {},
  intentHasChanged: false,
  setIntentHasChanged: () => {},
  slots: [],
  setSlots: () => {},
  refreshSlots: async () => {},
  updateSlot: async () => {},
  deleteSlot: async () => {},
  createSlot: async () => {},
  onNodeUpdate: () => {},
  onNodeDelete: () => {},
  addNode: () => {},
  unconnectedNodes: [],
  setUnconnectedNodes: () => {},
  removeNode: () => {},
  intentSlotMap: {},
  systemVariables: [],
  setSystemVariables: () => {},
  startInitializing: (_intentId: number) => {},
  finishInitializing: () => {}
});

export default BotBuilderContext;
